import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Alert, Button } from '@mui/material';

export default function DeleteUserDialog({ open, user, onClose, onDelete }) {
    const [submitting, setSubmitting] = React.useState(false);

    const handleDelete = async () => {
        setSubmitting(true);
        try { await onDelete(user); }
        finally { setSubmitting(false); }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Supprimer l’utilisateur</DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Cette action est irréversible. Confirmez la suppression de <b>{user?.email}</b>.
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button onClick={handleDelete} disabled={submitting} color="error" variant="contained">Supprimer</Button>
            </DialogActions>
        </Dialog>
    );
}
